import { Box, Button, FormHelperText, Link, Typography } from "@mui/material";
import { CLIENT_ID, REDIRECT_URI } from "./constants";
import { useTwoWaySyncEnabled } from "../useTwoWaySyncEnabled";
import { BookOpenText, NotebookPen } from "lucide-react";
import useIsMobile from "components/hooks/useIsMobile";

export default ({}: {}) => {
  const isTwoWaySyncEnabled = useTwoWaySyncEnabled();
  const _authUrl = (path: string) => {
    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?scope=email%20${path}&access_type=offline&response_type=code&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&prompt=consent`;
    return authUrl;
  };
  const fullWriteUrl = _authUrl("https://www.googleapis.com/auth/calendar");
  const fullReadUrl = _authUrl(
    "https://www.googleapis.com/auth/calendar.readonly",
  );

  const tileButtonSx = {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    gap: "12px",
    padding: "16px 20px",
    borderRadius: "12px",
    border: "1px solid #D4D4D4",
    flex: 1,
  };

  const isMobile = useIsMobile();

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="16px"
      justifyContent="center"
      sx={{ height: "100%" }}
    >
      {isTwoWaySyncEnabled && (
        <>
          {isMobile && (
            <Typography variant="h4" sx={{ marginBottom: "8px" }}>
              Select your Google Calendar permissions
            </Typography>
          )}

          <Box
            sx={{
              display: "flex",
              gap: "20px",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            <Link href={fullWriteUrl} sx={tileButtonSx}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  gap: "12px",
                }}
              >
                <Box>
                  <Typography variant="h5">Read and write access</Typography>
                  <Typography variant="bodySmallHeavy" color="primary.main">
                    Recommended
                  </Typography>
                </Box>
                <NotebookPen size={24} color="#198282" />
              </Box>
              <Typography variant="body">
                Your Advisor can manage your calendar events and schedule so
                everything is always up to date.
              </Typography>
            </Link>

            <Link href={fullReadUrl} sx={tileButtonSx}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  gap: "12px",
                }}
              >
                <Typography variant="h5">Read only</Typography>
                <BookOpenText size={24} color="#8E9598" />
              </Box>
              <Typography variant="body">
                Your Advisor will only be able to view events.
              </Typography>
            </Link>
          </Box>
        </>
      )}

      {!isTwoWaySyncEnabled && (
        <>
          <Typography variant="h4" sx={{ marginBottom: "8px" }}>
            Allow Faye to have read-only access to your calendar events
          </Typography>
          <Typography variant="body">
            We use this to schedule appointments, see availability, and to spot
            opportunities to help. You can select the accounts and calendars you
            want to share with your advisor.
          </Typography>
          <Box display="flex" flexDirection="column">
            <Button
              fullWidth
              color="primary"
              variant={isTwoWaySyncEnabled ? "outlined" : undefined}
              style={{ marginTop: isTwoWaySyncEnabled ? "12px" : "25px" }}
              href={fullReadUrl}
            >
              Connect Google Calendar
            </Button>
          </Box>
        </>
      )}
      <FormHelperText
        sx={{
          fontSize: "13px",
          fontWeight: "500",
          color: "#6B6E7B",
        }}
      >
        Faye's use and transfer to any other app of information received from
        Google APIs will adhere to{" "}
        <Link
          target="_new"
          href={
            "https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes"
          }
        >
          Google API Services User Data Policy
        </Link>
        , including the Limited Use requirements.
      </FormHelperText>
    </Box>
  );
};
